import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PropertyBookingsComponent } from './property-bookings.component';
import { FuseSharedModule } from '@fuse/shared.module';
import { BookingsCreateModalModule } from 'app/main/holiday-rentals/bookings/bookings-create-modal/bookings-create-modal.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';



@NgModule({
    declarations: [PropertyBookingsComponent],
    imports: [
        CommonModule,
        FuseSharedModule,
        MatButtonModule,
        MatIconModule,
        MatOptionModule,
        MatSelectModule,
        MatProgressSpinnerModule,
        MatDatepickerModule,
        MatMenuModule,
        MatToolbarModule,
        MatTooltipModule,
        MatDialogModule,
        BookingsCreateModalModule
    ],
    exports: [PropertyBookingsComponent]
})
export class PropertyBookingsModule { }
